import React from 'react'

const OrderStatus = ( { isPartialDelivery, wasCancelled, rxCheckSubsidy = false }) => {
  return (
    <div className="flexRow spaceBetween fullWidth">
      {isPartialDelivery ?
        <div className="cartInfoTag partial">DELLEVERANS</div>
        : null}
      {wasCancelled ?
        <div className="cartInfoTag cancelled">AVBRUTEN</div>
        : null}
      {rxCheckSubsidy ?
        <div className="cartInfoTag cancelled">SUBVENTIONSKONTROLL</div>
        : null}
    </div>
  )
}
export default OrderStatus